import axios from '../jslib/http'
const BASE_REQUEST = '/tms/customerGoods'
const BASE_REQUEST2 = '/tms/customerGoodsDetail'
import qs from 'qs'


export function getCustomerGoods(lineid, type) {
    const url = `${BASE_REQUEST}/getCustomerGoods`
    const data = {
        type: type
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}

export function getAddCustomerGoodsList(stowageId) {
    const url = `${BASE_REQUEST}/getAddCustomerGoodsList`
    const data = {
        stowageId: stowageId
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}
export function saveCustomerGoods(
    obj
) {
    const url = `${BASE_REQUEST}/saveCustomerGoods`
    const data = obj
    return axios
        .post(url, qs.stringify(data))
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}
export function updateCustomerGoods(
    obj
) {
    const url = `${BASE_REQUEST}/updateCustomerGoods`
    const data = obj
    return axios
        .post(url, qs.stringify(data))
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}
export function delCustomerGoods(
    id
) {
    const url = `${BASE_REQUEST}/delCustomerGoods`
    const data = {
        cgid: id
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}
export function saveGoodsDetail(
    obj
) {
    const url = `${BASE_REQUEST2}/saveGoodsInfo`
    var data = obj
    return axios
        .post(url, qs.stringify(data))
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}

export function getGoodsDetail(stowageId) {
    const url = `${BASE_REQUEST2}/getGoodsDetail`
    const data = {
        stowageId: stowageId
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}

export function delCustomerGoodsInDetail(goodsId) {
    const url = `${BASE_REQUEST2}/delCustomerGoods`
    const data = {
        goodsId: goodsId
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}
export function getUserByName(
    userName
) {
    const url = `${BASE_REQUEST}/getUserByName`
    const data = {
        userName: userName
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}

export function getCustomerGoodsById(pageNo, pageSize, goodsId, stowageId) {
    const url = `${BASE_REQUEST}/getCustomerGoodsById`
    const data = {
        pageNo: pageNo,
        pageSize: pageSize,
        goodsId: goodsId,
        stowageId: stowageId
    }
    return axios
        .get(url, {
            params: data
        })
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}
export function updateCustomerGoodsDetail(
    obj
) {
    const url = `${BASE_REQUEST2}/updateCustomerGoodsDetail`
    const data = obj
    return axios
        .post(url, qs.stringify(data))
        .then(res => {
            if (res !== undefined) {
                return Promise.resolve(res.data)
            } else {
                return Promise.resolve(res)
            }
        })
}
